export const TAB_FILTER = {
  FOLLOWING: 'FOLLOWING',
  VIOLATED: 'VIOLATED',
  ALUMNI: 'ALUMNI',
  ALL: 'ALL',
} as const;

export type TabFilterValue = (typeof TAB_FILTER)[keyof typeof TAB_FILTER];
